import moment from 'moment';

export const getDefaultDemandRange = (): [fromDate: string, toDate: string] => {
    const fromDate = moment.utc(moment()).startOf('day').toISOString();
    const toDate = moment.utc(moment().add(120, 'days')).endOf('day').toISOString();
    return [fromDate, toDate];
};
